
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { useToast } from '@/hooks/use-toast';
import { supabase } from '@/integrations/supabase/client';

interface NewsletterSectionProps {
  hideHeading?: boolean;
}

const NewsletterSection = ({ hideHeading = false }: NewsletterSectionProps) => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { toast } = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const { error } = await supabase
        .from('newsletter_subscriptions')
        .insert({ email });

      if (error) {
        if (error.code === "23505") {
          toast({
            title: "Already Subscribed",
            description: "This email is already on our newsletter list.",
            variant: "default",
          });
        } else {
          throw error;
        }
        return;
      }

      setEmail('');
      toast({
        title: "Subscription Successful",
        description: "Thank you for subscribing to our newsletter!",
        variant: "default",
      });
    } catch (err) {
      console.error('Subscription error:', err);
      toast({
        title: "Subscription Failed",
        description: "There was an error subscribing to the newsletter. Please try again.",
        variant: "destructive",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="text-center space-y-8">
      {!hideHeading && (
        <h1 className="text-4xl md:text-5xl font-mono font-bold">
          Join our newsletter
        </h1>
      )}
      <form 
        onSubmit={handleSubmit}
        className="max-w-2xl mx-auto flex flex-col sm:flex-row gap-4"
      >
        <Input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="flex-1 text-lg font-mono"
          required
          disabled={isSubmitting}
        />
        <Button
          type="submit"
          className="bg-[#ff5733] hover:bg-[#ff5733]/90 text-white font-mono text-lg px-8"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Subscribing...' : 'Subscribe'}
        </Button>
      </form>
    </div>
  );
};

export default NewsletterSection;
